import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const SubscriptionPlanStyles = styled(Modal)`
  .modal-header {
    padding: 0 !important;
    width: 100%;
    .modal-title {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      color: #1f1f1f;
      text-transform: capitalize;
    }
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 16px;
    width: 100%;

    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.14px;
      color: var(--Neutral-100);
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 8px;

    button {
      min-width: 120px;
      padding: 0 14px;
    }
  }
`;
